// extracted by mini-css-extract-plugin
export default {"secondary":"secondary___M2esE","tiny":"tiny___piVWF"};